<template>
    <div>
        <v-layout row wrap>
            <v-flex>
                <material-creation-form
                    :readOnly="readOnly"
                    v-if="materialCreationFormVisible"
                    :value="creationFormState"
                    :checkMaterialExistsFunc="checkMaterialExists"
                    @create="handleCreateMaterial"
                    @cancel="handleCancelMaterialCreation"
                ></material-creation-form>
                <v-btn :disabled="readOnly"
                       color="success"
                       v-if="!materialCreationFormVisible"
                       @click="handleClickCreateMaterialButton">{{ $t('materials.buttons.addMaterial.title') }}</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex v-if="materialsSectionVisible('tissues')">
                <h4 v-t="'materials.subtitle.tissues'"></h4>
                <materials-list :readOnly="readOnly" :items="materialsByType['tissues']" type="tissues" @delete="e => {handleDeleteMaterial('tissues', e) }"></materials-list>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex v-if="materialsSectionVisible('blocks')">
                <h4 v-t="'materials.subtitle.blocks'"></h4>
                <materials-list :readOnly="readOnly" :items="materialsByType['blocks']" type="blocks" @delete="e => {handleDeleteMaterial('blocks', e) }"></materials-list>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex v-if="materialsSectionVisible('slides')">
                <h4 v-t="'materials.subtitle.slides'"></h4>
                <materials-list :readOnly="readOnly" :items="materialsByType['slides']" type="slides" @delete="e => {handleDeleteMaterial('slides', e) }"></materials-list>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="additionalMaterialsVisible">
            <v-flex>
                <v-layout row>
                    <v-flex>
                        <h3>{{ $t('caseCreationOrderForm.subtitle.additionalMaterials.label') }}</h3>
                    </v-flex>
                </v-layout>
                <v-layout column>
                    <v-flex v-if="materialsSectionVisible('files')">
                        <h4 v-t="'materials.subtitle.files'"></h4>
                        <materials-list :readOnly="readOnly" :items="materialsByType['files']" type="files" @delete="e => {handleDeleteMaterial('files', e) }"></materials-list>
                    </v-flex>
                    <v-flex v-if="materialsSectionVisible('documents')">
                        <h4 v-t="'materials.subtitle.documents'"></h4>
                        <materials-list :readOnly="readOnly" :items="materialsByType['documents']" type="documents" @delete="e => {handleDeleteMaterial('documents', e) }"></materials-list>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

  import MaterialCreationForm from './MaterialCreationForm'
  import MaterialsList from './MaterialsList'
  import _ from 'lodash'

  export default {
    name: "materials",
    props: {
      creationFormState: {
        Type: Object
      },
      materialsByType: {
        Type: Object
      },
      readOnly: {
        Type: Boolean
      },
      checkMaterialExistsFunc: {
        Type: Function
      }
    },
    components: {
      MaterialCreationForm,
      MaterialsList
    },
    data () {
      return {
        materialCreationFormVisible: !!this.creationFormState,
      }
    },
    watch: {
      creationFormState: function() {
        if (this.creationFormState !== null && !this.readOnly){
            this.materialCreationFormVisible = !!this.creationFormState
        }
      }
    },
    computed: {
      additionalMaterialsVisible () {
        return this.materialsSectionVisible('files') || this.materialsSectionVisible('documents')
      },
    },
    methods: {
      checkMaterialExists(code) {
        return this.checkMaterialExistsFunc(code)
      },
      handleClickCreateMaterialButton() {
        this.materialCreationFormVisible = !this.materialCreationFormVisible
      },
      handleCreateMaterial(material) {
        this.$emit('createMaterial', material)
        this.materialCreationFormVisible = !this.materialCreationFormVisible
      },
      handleCancelMaterialCreation() {
        this.materialCreationFormVisible = !this.materialCreationFormVisible
      },
      handleDeleteMaterial(type, code) {
        this.$emit('deleteMaterial', {type, code})
      },
      materialsSectionVisible(type) {
        const materials = _.get(this.materialsByType, type, [])

        return materials && materials.length > 0
      }
    }
  }
</script>

<style scoped>

</style>